(function() {

	/**
	 * @type BasketBlock
	 */
	var BasketBlock = (/** @constructor */ function() {
		var basket_empty = 'корзина пуста';
		/** @type {Object} параметры */
		var opt = {
			fullBasket : function(count, text) {
				return count+' '+text;
			}
		};

		var $obj;

		return {
			/**
			 * @memberOf BaksetBlock
			 * @param {Object} options
			 */
			init : function(options) {
				$.extend(opt, options);
				$obj = $(opt.selector);
			},

			/**
			 * Обновить поле корзины
			 * @param {Number} count кол-во товаров
			 */
			update : function(count) {
				if (count > 0) {
					var basket_count = ['товар', 'товара', 'товаров'];
					var gs = basket_count[2],
						d100 = count % 100,
						d10 = count % 10;
					if ((d100 < 5) || (d100 > 20)) {
						if (d10 == 1) {
							gs = basket_count[0];
						} else  if (d10 > 1 && d10 < 5) {
							gs = basket_count[1];
						}
					}
					$('.basket-total span').html(count);
					$obj.html(opt.fullBasket(count, gs));
					$obj.removeClass('empty');
				} else {
					$obj.html(basket_empty);
					$obj.addClass('empty');
				}
			}

		};
	})();
	Order.BasketBlock = BasketBlock;

})();